module.exports = __webpack_public_path__ + "img/logo.6c127d34.png";